
import * as THREE from 'three';
import Phobject from './Phobject.js'

export default class Block extends Phobject {
    constructor(color){
        super(true);
        
        let toM = function(n){
            return n/39.37;
        }
        this.dimBlock = new THREE.Vector3(toM(2),toM(2),toM(2));

        this.group = new THREE.Group();

        var matBlock = new THREE.MeshBasicMaterial( {color: color, transparent: true, opacity:.3, wireframe: false});
        var geoBlock = new THREE.BoxBufferGeometry( this.dimBlock.x,this.dimBlock.y,this.dimBlock.z);
        let meshBlock = new THREE.Mesh( geoBlock, matBlock );        
        
        this.group.add(meshBlock);
    }

    getObject(){
        return this.group;
    }

    setupPhysics(pos){
        this.group.position.copy(pos);
        // physics
        var options = {
            type:'box',
            size:[this.dimBlock.x, this.dimBlock.y, this.dimBlock.z],
            pos:[pos.x,pos.y,pos.z],
            density:5,
            move:this.move
        }
    
        this.phobject = this.world.add( options );
        this.phobject.angularVelocity.z=(Math.random()-.5)*2;
        this.phobject.angularVelocity.x=-Math.random();
    }
}
